import React from 'react';
import { motion } from 'framer-motion';

export function BentoGrid({ children, className = '' }) {
  return (
    <div className={`grid w-full auto-rows-[22rem] grid-cols-3 gap-4 ${className}`}>
      {children}
    </div>
  );
}

export function BentoCard({
  name,
  className = '',
  background,
  Icon,
  description,
  href,
  cta,
}) {
  return (
    <motion.div
      className={`group relative flex flex-col justify-between overflow-hidden rounded-xl ${className}`}
      style={{
        backgroundColor: 'var(--color-surface)',
        border: '1px solid rgba(60,74,60,0.2)',
      }}
      whileHover={{ y: -4 }}
      transition={{ duration: 0.3 }}
    >
      {/* Background decoration */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        {background}
      </div>

      {/* Content — anchored at bottom */}
      <div className="pointer-events-none z-10 flex flex-col gap-1 p-4 sm:p-6 pb-4 sm:pb-14 transition-all duration-300 translate-y-0 sm:translate-y-10 sm:group-hover:translate-y-0"
        style={{ marginTop: 'auto' }}
      >
        {Icon && (
          <Icon className="h-8 w-8 sm:h-12 sm:w-12 origin-left text-on-surface-variant transition-all duration-300 ease-in-out group-hover:scale-75" />
        )}
        <h3 className="text-base sm:text-xl font-bold text-white font-headline">{name}</h3>
        <p className="max-w-lg text-on-surface-variant text-xs sm:text-sm">{description}</p>
      </div>

      {/* Hover CTA */}
      {cta && href && (
        <div className="pointer-events-none absolute bottom-0 flex w-full translate-y-10 flex-row items-center p-4 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <a
            href={href}
            className="pointer-events-auto flex items-center gap-1 text-sm font-medium text-primary"
          >
            {cta}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14" />
              <path d="m12 5 7 7-7 7" />
            </svg>
          </a>
        </div>
      )}

      {/* Hover border glow */}
      <div
        className="pointer-events-none absolute inset-0 rounded-xl opacity-0 transition-opacity duration-500 group-hover:opacity-100"
        style={{
          border: '1px solid rgba(81,225,165,0.25)',
          boxShadow: 'inset 0 0 40px rgba(81,225,165,0.04)',
        }}
      />
    </motion.div>
  );
}
